import React, { useState } from "react";
import { Button, StyledText } from "../../../../components/common";
import { BackIcon, NoticeIcon } from "../../../../components/svgs";
import { useTheme } from "../../../../hooks";
import { useHistory } from "react-router-dom";
import TriviaInfoModal from "../../trivia/TriviInfoModal";
import styled from "styled-components";
import PeerTalkIcons from "./PeerTalkIcons";

const ModalOverlay = styled.div`
  position: absolute;
  z-index: 100;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
`;

const ModalContent = styled.div`
  position: absolute;
  z-index: 100;
  width: 100%;
  bottom: 0;
  box-sizing: border-box;
  padding: 0px 20px;
  height: 55%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: white;
  margin-top: 70%;
  border-top-right-radius: 15px;
  border-top-left-radius: 15px;
`;

const Header = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  margin-top: 5px;
  margin-bottom: 5px;
`;

const CloseButton = styled.div`
  cursor: pointer;
`;

const IconsContainer = styled.div`
  width: 100%;
`;

const YoungsterModal = ({ onBackDropClick }) => {
  const { themeContext, theme } = useTheme();
  const [showTriviaInfo, setShowTriviaInfo] = useState(false);

  let themeColor = "background";
  let background = theme.colors[themeContext.activeTheme][themeColor];
  let history = useHistory();

  return (
    <>
      <ModalOverlay onClick={onBackDropClick} />
      <ModalContent onClick={(e) => e.stopPropagation()}>
        <div
          style={{
            width: 50,
            height: 8,
            backgroundColor: "#cbcbcb",
            borderRadius: 10,
          }}
        />
        <Header>
          <CloseButton onClick={onBackDropClick}>
            <BackIcon />
          </CloseButton>
        </Header>

        <IconsContainer>
          <PeerTalkIcons />
        </IconsContainer>
        <StyledText style={{ fontSize: 20 }}>
          Youngster Pulse is here!
        </StyledText>
        <StyledText
          style={{
            textAlign: "center",
            fontFamily: "MTNRegular",
            paddingInline: 15,
          }}
        >
          Get answers to your questions and share your thoughts with other
          Pulsers, all anonymously in a safe place.
        </StyledText>
        <Button
          style={{ backgroundColor: background, width: "80%" }}
          onClick={() => history.push("/peer_talk/peertalk_info")}
        >
          <StyledText color="white">LEARN MORE</StyledText>
        </Button>
      </ModalContent>
      {showTriviaInfo && (
        <TriviaInfoModal onBackButtonClick={() => setShowTriviaInfo(false)} />
      )}
    </>
  );
};

export default YoungsterModal;
